// extracted by mini-css-extract-plugin
export default {"Dropdown":"uhC4sgoh","PlaceholderDropdown":"T5woCe67"};